type AdvantageCardProps = {
  title: string;
  description: string;
  icon: string;
  iconPosition?: string;
};

export default function AdvantageCard({ title, description, icon, iconPosition }: AdvantageCardProps) {
  // Only treat 'left' as left, everything else (including undefined) is 'right'
  const isLeft = iconPosition === 'left';
  return (
    <div
      className={`w-full h-full px-6 lg:px-12 py-8 lg:py-2 bg-[#FAFAFA] overflow-hidden rounded-3xl lg:rounded-[64px] outline outline-1 outline-[#E5E7EB] outline-offset-[-1px] flex flex-col lg:flex ${isLeft ? 'lg:flex-row-reverse' : 'lg:flex-row'} justify-center items-center gap-6 lg:gap-10`}
    >
      <div className="flex flex-col justify-start items-start gap-4 lg:gap-8 w-full lg:flex-1 min-w-0">
        <div className="w-full text-black text-xl lg:text-2xl font-avenir font-bold break-words">{title}</div>
        <div className="w-full flex justify-center items-center gap-2.5">
          <div className="flex-1 text-black font-avenir font-normal break-words text-sm lg:text-xl whitespace-pre-line">
            {description}
          </div>
        </div>
      </div>
      <img
        className="w-full max-w-xs lg:w-auto lg:max-w-md lg:flex-shrink-0 h-auto object-contain"
        src={icon}
        alt="icon"
      />
    </div>
  );
}
